import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./LandingPage.css";

const APPLE_URL = "https://apps.apple.com/pk/app/ritesoccer/id6754843547";
const GOOGLE_URL = "https://play.google.com/store/apps/details?id=com.RiteSoccer.RiteSoccer";

const StoreButtons = ({ center }) => (
  <div className={`store-buttons${center ? " store-buttons--center" : ""}`}>
    <a href={APPLE_URL} target="_blank" rel="noopener noreferrer" className="store-link">
      <div className="store-btn">
        <svg className="store-icon" viewBox="0 0 24 24">
          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
        </svg>
        <div className="store-text">
          <span className="store-label">Download on the</span>
          <span className="store-name">App Store</span>
        </div>
      </div>
    </a>
    <a href={GOOGLE_URL} target="_blank" rel="noopener noreferrer" className="store-link">
      <div className="store-btn">
        <img src="./assets/playstore.png" alt="Google Play" className="store-icon" />
        <div className="store-text">
          <span className="store-label">Get it on</span>
          <span className="store-name">Google Play</span>
        </div>
      </div>
    </a>
  </div>
);

const LandingPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Is it free?",
      answer: " Yes. Core social features are free. We'll add optional premium tiers for users later."
    },
    {
      question: "How do gifts/coins work?",
      answer: "Users purchase coins and send virtual gifts. Users may convert earnings to wallet credits, subject to platform terms."
    },
    {
      question: "Is this betting?",
      answer: "No. Rite Soccer focuses on social engagement, challenges, and talent discovery — not gambling"
    },
    {
      question: "Can clubs and academies join?",
      answer: " Yes. We provide tools and onboarding support for clubs, academies, and agents."
    },
    {
      question: "What countries do you support?",
      answer: "It is a Global app."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* Bootstrap CSS */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/css/bootstrap.min.css"
        rel="stylesheet"
      />

      <div className="landing-page">
        {/* Hero Section */}
        <section className="hero">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="hero-content">
                  <h1 className="hero-title">
                    Football finally has its own social home.
                  </h1>
                  <p className="hero-subtitle">
                    A global football platform where players showcase talent,
                    fans banter and follow matches live, and scouts/agents/clubs
                    discover the next stars. A home for all users to do
                    everything football.
                  </p>
                  <div className="d-flex justify-content-center align-items-center mb-4">
                    <StoreButtons center />
                  </div>
                  <div className="hero-phones"></div>
                  <div className="phone">
                    <img
                      src="./assets/hero-img.png"
                      alt="App Screen"
                      className="d-block mx-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How it Works Section */}
        <section className="how-it-works">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h4 className="before-heading text-center"> Key Features</h4>
                <h2 className="section-title" id="how-it-works">How it works</h2>
                <p className="section-subtitle">
                  Getting started is easy with just three simple ways
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12 mb-4">
                <div className="step">
                  <div className="step-icon">
                    <img src="./assets/key-feat-1.png" />
                  </div>
                  <h3> Create your account</h3>
                  <p>
                    Choose Player, Fan, or Scout/Agent/Club and set up your
                    profile.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4">
                <div className="step">
                  <div className="step-icon">
                    <img src="./assets/key-feat-2.png" />
                  </div>
                  <h3>Create or enter live rooms</h3>
                  <p>
                    Post clips, create or enter live rooms, follow match hubs
                    and discover talents
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-12 mb-4">
                <div className="step">
                  <div className="step-icon">
                    <img src="./assets/key-feat-3.png" />
                  </div>
                  <h3>Grow & earn</h3>
                  <p>
                    Climb leaderboards, get noticed, and unlock creator earnings
                    through virtual gifts.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-center">
                <StoreButtons center />
              </div>
            </div>
          </div>
        </section>

        {/* Be Seen Be Scouted Section */}
        <section className="be-seen-section">
          <div className="container">
            <div className="row align-items-center" id="be-seen">
              <div className="col-lg-6 col-12">
                <div className="content-left" style={{ textAlign: "left" }}>
                  <h4 className="before-heading">Players</h4>
                  <h2>Be seen. Be scouted.</h2>
                  <ul className="feature-list" style={{ padding: "0px" }}>
                    <li>Receive virtual gifts from any user</li>
                    <li>Upload highlight videos & skills clips</li>
                    <li>
                      Join Challenges to climb leaderboards and earn fan support
                    </li>
                    <li>Get discovered by scouts and academies worldwide</li>
                    <li>
                      Build a real football profile (position, foot, height,
                      stats)
                    </li>
                  </ul>
                  <p className="player-detail">
                    Players don't just showcase, they also join live match
                    chats, receive/send gifts, banter with fans, and connect
                    with peers worldwide.
                  </p>
                  <StoreButtons />
                </div>
              </div>
              <div className="col-lg-5 col-12">
                <div className="content-right">
                  <div className="phone-mockup text-center">
                    <img src="./assets/players.png" alt="Profile Screen" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Live the Game Section */}
        <section className="live-game-section">
          <div className="container">
            <div className="row align-items-center" id="be-seen">
              <div className="col-lg-5 col-12 order-lg-1 order-2">
                <div className="content-left">
                  <div className="phone-mockup text-center">
                    <img src="./assets/fans.png" alt="Game Screen" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-12 order-lg-2 order-1">
                <div className="content-right" style={{ textAlign: "left" }}>
                  <h4 className="before-heading">Fans</h4>
                  <h2>Live the game together.</h2>
                  <ul className="feature-list" style={{ padding: "0px" }}>
                    <li>Live rooms for match commentary and banter</li>
                    <li>Match Hubs with real-time threads and polls</li>
                    <li>Follow players, share takes, create fan clubs</li>
                    <li>
                      Send virtual gifts to your favorite creators and moments
                    </li>
                  </ul>
                  <p className="fan-detail">
                    Fans can post takes, start groups, and build communities
                    beyond match days.
                  </p>
                  <StoreButtons />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Faster Path Section */}
        <section className="faster-path-section">
          <div className="container">
            <div className="row align-items-center" id="be-seen">
              <div className="col-lg-6 col-12">
                <div className="content-left" style={{ textAlign: "left" }}>
                  <h4 className="before-heading">Scout / Club / Leagues / Football Organizations</h4>
                  <h2 style={{ fontSize: "40px", whiteSpace: "nowrap" }}>
                    A faster path to getting talent.
                  </h2>
                  <ul className="feature-list" style={{ padding: "0px" }}>
                    <li>Search players by position, age, location, and tags</li>
                    <li>Shortlist, DM, and track prospects</li>
                    <li>
                      Discover emerging talent via Challenges & community
                      signals
                    </li>
                    <li>Stream matches and events live</li>
                    <li>Monetize audiences directly through paid streams</li>
                    <li>Create content around clubs, teams, and tournaments</li>
                    <li>
                      Open additional monetization opportunities through
                      gifting, sponsorships, and creator engagement
                    </li>
                  </ul>
                  <p className="club-detail">
                    From grassroots football to organized leagues and academies,
                    Rite Soccer helps football organizations turn attention into
                    community and community into opportunity.
                  </p>
                  <StoreButtons />
                </div>
              </div>
              <div className="col-lg-5 col-12">
                <div className="content-right">
                  <div className="phone-mockup text-center">
                    <img src="./assets/clubs.png" alt="Talent Screen" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What Makes Different Section */}
        <section className="different-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h4 className="before-heading text-center">
                  Signature features
                </h4>
                <h2 className="section-title">
                  What makes Rite Soccer different
                </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12 mb-3">
                <div className="feature-card">
                  <div className="feature-icon">
                    <img src="./assets/sig-feat-1.png" />
                  </div>
                  <h3>Player Profiles</h3>
                  <p>
                    Verified details, positions, metrics, and clips designed for football discovery.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <img src="./assets/sig-feat-2.png" />
                  </div>
                  <h3>Live Events Audio/Video</h3>
                  <p>
                    Host match watch-alongs, post-game analysis, or AMA sessions.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <img src="./assets/sig-feat-3.png" />
                  </div>
                  <h3>Match Hub</h3>
                  <p>
                    Real time threads per fixture: lineups, moments, polls, best takes.                  </p>
                </div>
              </div>


              <div className="col-lg-4 col-md-6 col-12 mb-4 special-box">
                <div className="feature-card">
                  <div className="feature-icon">
                    <img src="./assets/sig-feat-2.png" />
                  </div>
                  <h3>Challenges & Leaderboards</h3>
                  <p>
                    Skill challenges (freestyle, finishing, pace). Community voting + spotlights.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4 special-box">
                <div className="feature-card">
                  <div className="feature-icon">
                    <img src="./assets/sig-feat-3.png" />
                  </div>
                  <h3>Safety & Security</h3>
                  <p>
                    Reporting, moderation, and verified accounts for scouts/clubs.
                  </p>
                </div>
              </div>


              <div className="row justify-content-center mt-3">
                <div className="col-lg-4 col-md-6 col-12 mb-2 f-box">
                  <div className="feature-card text-center">
                    <div className="feature-icon">
                      <img src="./assets/sig-feat-4.png" alt="Challenges" />
                    </div>
                    <h3>Challenges & Leaderboards</h3>
                    <p>
                      Skill challenges (freestyle, finishing, pace). Community voting + spotlights.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6 col-12 mb-2 f-box">
                  <div className="feature-card text-center">
                    <div className="feature-icon">
                      <img src="./assets/sig-feat-5.png" alt="Safety" />
                    </div>
                    <h3>Safety & Security</h3>
                    <p>
                      Reporting, moderation, and verified accounts for scouts/clubs.

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*Early Access Section*/}
        <section className="access-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12 mb-2">
                    <div className="access-item">
                      <div className="access-icon">
                        <img src="./assets/access-1.png" />
                      </div>
                      <div className="access-content">
                        <h3>Reserved Handle</h3>
                        <p>Get your preferred username + early badge</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-2">
                    <div className="access-item">
                      <div className="access-icon">
                        <img src="./assets/access-2.png" />
                      </div>
                      <div className="access-content">
                        <h3>Priority Onboarding</h3>
                        <p>Special support for clubs, academies & teams</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-2">
                    <div className="access-item">
                      <div className="access-icon">
                        <img src="./assets/access-3.png" />
                      </div>
                      <div className="access-content">
                        <h3>Creator Perks</h3>
                        <p>
                          Early benefits for room hosts and content creators
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Launch Roadmap Section */}
        <section className="roadmap-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h4 className="before-heading text-center">
                  Platform Features
                </h4>
                <h2 className="section-title" id="launch-roadmap" style={{ fontSize: "32px" }}>Football-native experiences designed for fans, players, creators, clubs, and communities.</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12 mb-4">
                <div className="roadmap-item">
                  <div className="roadmap-icon">
                    <img src="./assets/1-icon.png" />
                  </div>
                  <div className="roadmap-content">
                    <h4>Battles</h4>
                    <p>
                      Join prediction battles, skill battles, and banter rooms where football fans and players compete, interact, and engage live.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12 mb-4">
                <div className="roadmap-item">
                  <div className="roadmap-icon">
                    <img src="./assets/2-icon.png" />
                  </div>
                  <div className="roadmap-content">
                    <h4>Live Interactions</h4>
                    <p>
                      Create content, join live rooms, react to matches in real
                      time, and connect with football communities globally.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-12 mb-4">
                <div className="roadmap-item">
                  <div className="roadmap-icon">
                    <img src="./assets/3-icon.png" />
                  </div>
                  <div className="roadmap-content">
                    <h4>Rite Streams</h4>
                    <p>
                      Clubs, leagues, and football organizations stream matches
                      live, set viewing prices, and monetize audiences directly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-center">
                <StoreButtons center />
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq-section-latest">
          <div className="container">
            <div className="row-latest">
              <div className="col-12">
                <h4 className="before-heading-latest text-center">FAQs</h4>
                <h2 className="section-title-latest" id="faq-latest">
                  Frequently asked questions
                </h2>
                <p className="section-subtitle-latest" id="faq-subtitle-latest">
                  If you can't find what you are looking for don't hesitate to contact us.
                </p>
              </div>
            </div>

            <div className="row-latest">
              <div className="col-12">
                <div className="faq-list-latest">
                  {faqs.map((faq, index) => (
                    <div
                      key={index}
                      className={`faq-item-latest ${activeIndex === index ? "active" : ""}`}
                    >
                      <div
                        className="faq-header-latest"
                        onClick={() => toggleFAQ(index)}
                      >
                        <h3 className="faq-question" id="faq-question">{faq.question}</h3>
                        <span className="faq-toggle-latest">
                          <img
                            src="./assets/plus.png"
                            alt="toggle"
                            className={activeIndex === index ? "rotate" : ""}
                          />
                        </span>
                      </div>
                      {activeIndex === index && (
                        <div className="faq-content-latest">
                          <p className="faq-answer">{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section className="final-cta">
          <div className="container">
            <div className="row align-items-center">
              {/* Left Content */}
              <div className="col-lg-7 col-md-12">
                <div className="cta-content">
                  <h4>Download the App</h4>

                  <h2>Ready to join the future of football?</h2>
                  <p>
                    Be part of the global football community that connects
                    players, fans, and scouts like never before.
                  </p>
                  <StoreButtons />
                </div>
              </div>

              {/* Right Image */}
              <div className="col-lg-5 col-md-12 " id="vector-img" style={{ display: "flex", justifyContent: "flex-end" }}>
                <img
                  src="/assets/vector.png"
                  alt="Football Vector"
                  className="vector-image"
                />
              </div>
            </div>
          </div>
        </section>


        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="text-center">
              <img
                src="./assets/footer-logo.png"
                alt="Rite Soccer Logo"
                className="mb-3 footer-logo"
              />

              <h2>Let's connect</h2>

              <p>
                Say hello by email for inquiries, support, partnerships or
                promotion <br></br>
                (
                <a href="mailto:info@ritesoccer.com">info@ritesoccer.com</a>)
              </p>
              <div className="col-12 text-center mb-4">
                <p className="mb-0 address">
                  <img src="./assets/map.png" style={{ width: '14px' }} /> 35 Payne Street, Quincy MA.
                </p>
              </div>

              {/* Social Icons Row */}
              <div className="row justify-content-center g-3 social-icons">
                <div className="col-auto">
                  <a href="https://x.com/ritesoccer">
                    <img src="./assets/x-icon.png" alt="X" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="https://www.instagram.com/ritesoccer/">
                    <img src="./assets/instagram-icon.png" alt="Instagram" />
                  </a>
                </div>
                <div className="col-auto">
                  <a href="https://www.facebook.com/profile.php?id=61579842483993">
                    <img src="./assets/tiktok-icon.png" alt="TikTok" />
                  </a>
                </div>
              </div>
            </div>

            <div className="row copy-right">
  <div className="col-6 text-start">
    <p className="mb-0 c1">
      © 2024 Rite Soccer. All rights reserved.
    </p>
  </div>
  <div
    className="col-6 text-end"
    style={{
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      justifyContent: "flex-end",
    }}
  >
    <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
      terms & conditions
    </Link>
    <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
      privacy policy
    </Link>
  </div>
</div>

<div className="copy-right-mob">
  <div className="col-mob text-center">
    <p className="mb-0 c1">
      © 2024 Rite Soccer. All rights reserved.
    </p>
  </div>
  <div
    className="col-12 text-end"
    style={{
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      justifyContent: "center",
    }}
  >
    <Link to="/terms" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
      terms & conditions
    </Link>
    <Link to="/privacy" className="mb-0 address btn btn-link p-0" style={{color:'white', textDecoration: 'none'}}>
      privacy policy
    </Link>
  </div>
</div>

          </div>
        </footer>
      </div>

      {/* Bootstrap JS */}
      <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.2/js/bootstrap.bundle.min.js"></script>
    </>
  );
};

export default LandingPage;
